<template>
	<div class="memberCreate">
		<div class="fields">
			<b-field label="Card Number *" v-if="!nrm">
				<input name="cardNumber" placeholder="Card Number" v-model="cardNumber" autocomplete="off" class="input" />
			</b-field>

			<b-field label="Name *">
				<input name="name" placeholder="Name" v-model="name" autocomplete="off" class="input" />
			</b-field>

			<b-field label="Phone *">
				<input name="phone" placeholder="Phone" v-model="phone" autocomplete="off" class="input" />
			</b-field>

			<b-field label="Email">
				<input name="email" placeholder="Email" v-model="email" autocomplete="off" class="input" />
			</b-field>

			<b-field label="NRC *">
				<input name="nrc" placeholder="NRC" v-model="nrc" autocomplete="off" class="input" />
			</b-field>

			<b-field label="Date of Birth *">
				<b-datepicker placeholder="Click to select..." v-model="dob" :date-formatter="dateFormatter" icon="calendar-today" trap-focus> </b-datepicker>
			</b-field>

			<b-field label="Address *">
				<input name="address" placeholder="Address" v-model="address" autocomplete="off" class="input" />
			</b-field>

			<p class="label">Gender *</p>
			<b-radio v-model="gender" name="Gender" native-value="M">Male</b-radio>
			<b-radio v-model="gender" name="Gender" native-value="F">Female</b-radio>
			<br /><br />

			<p class="label">Marital Status *</p>
			<b-radio v-model="maritalStatus" name="maritalStatus" native-value="S">Single</b-radio>
			<b-radio v-model="maritalStatus" name="maritalStatus" native-value="M">Married</b-radio>
			<b-radio v-model="maritalStatus" name="maritalStatus" native-value="D">Divorced</b-radio>

			<br />
			<br />
			* = Required fields
			<br />
			<br />
			<div class="submit-button" @click="submit()">SAVE</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'settings',

	data: function() {
		return {
			cardNumber: null,
			name: null,
			phone: '09',
			email: null,
			nrc: null,
			dob: null,
			gender: 'F',
			maritalStatus: 'S',
			tier: '5e7486080ab3e95f2debf641',
			address: null,
			nrm: false,
			status: 1
		}
	},

	components: {},

	watch: {
		phone: function(newData) {
			// Remove spaces
			newData = newData.replace(/\s+/g, '')

			// Remove dashes
			newData = newData.replace(/-/g, '')

			this.phone = newData
		}
	},

	mounted: async function() {
		if (this.$store.state.logo == 'nrm') {
			this.nrm = true
		}
	},

	methods: {
		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// When user clicked on submit
		submit: async function() {
			if (!this.name || !this.phone || !this.nrc || !this.dob) {
				this.$swal.fire('Required!', 'Please check required fields!', 'error')

				return
			}

			if (!this.nrm && !this.cardNumber) {
				this.$swal.fire('Required!', 'Please check required fields!', 'error')

				return
			}

			let jx_dob = this.$moment(this.dob).format('x')

			let data = {
				card_number: this.cardNumber,
				name: this.name,
				mobile_phone: this.phone,
				status: this.status,
				nrc: this.nrc,
				address: this.address,
				dob: jx_dob,
				gender: this.gender,
				tier: this.tier,
				marital_status: this.maritalStatus
			}

			if (this.nrm) {
				data.tier = '5eeae97284d11a3cfa5e3714'
			}

			data.password = 'BDP' + Math.floor(Math.random() * (1111111 - 9999999) + 1111111)

			if (this.email) {
				data.email = this.email
			}

			const apiCreateMember = await this.$api.createMember({ data })

			if (!apiCreateMember) {
				return
			}

			this.$swal.fire(apiCreateMember.data.card_number, 'Member Registered Successfully! ID ' + apiCreateMember.data.card_number, 'success')

			// Clean data
			this.cardNumber = null
			this.name = null
			this.phone = '09'
			this.email = null
			this.nrc = null
			this.dob = null
			this.gender = 'F'
			this.maritalStatus = 'S'
			this.address = null
		}
	}
}
</script>

<style scoped>
.memberCreate {
	font-size: 12px;
}

.input {
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	font-family: 'poppinssemibold';
	font-size: 13px;
	height: 40px;
	width: 100%;
	padding-left: 10px;
	margin: 0;
	border-radius: 4px;
	border: 1px solid #d5e3f5;
	background-color: #fff;
}

.input:focus {
	border: 2px solid #1c2d40;
}

.fields {
	width: 500px;
	margin: auto;
	text-align: left;
}

.fields .field {
	margin-bottom: 2em;
}

.submit-button {
	margin: auto;
	background-color: #62c7c2;
	text-align: center;
	padding: 20px 0;
	border: 1px solid #62c7c2;
	border-radius: 3px;
	color: #fff;
	cursor: pointer;
	width: 100px;
}
</style>
